<template>
  <div>{{ message }}</div>
</template>

<script>
import Auth from "@/apis/Auth";

export default {
  props: {
    token: [String],
  },
  data() {
    return {
      message: this.$t("heading.ssoLoginPage.title"),
      appUrl: "",
    };
  },
  created() {
    Auth.home().then((response) => {
      if (
        response.data.admin === undefined &&
        response.data.user.password_change_required
      ) {
        this.$router.push({
          path: "/my-account",
          query: {
            change_password_required: true,
          },
        });
        return;
      }
      if (
        response.data.admin === undefined &&
        response.data.user.two_factor_auth_required
      ) {
        this.$router.push({
          path: "/my-account",
          query: {
            two_factor_auth_required: true,
          },
        });
        return;
      }
      let isUserReseller =
        "reseller_settings" in response.data.user &&
        response.data.user.reseller_settings !== null;
      if (!isUserReseller) {
        this.triggerStyleManager();
      }
      if (this.$route.query.redirect) {
        this.$router.push({ path: this.$route.query.redirect });
        return;
      }
      this.$router.push({ path: "/instances" });
    });
  },
  methods: {
    triggerStyleManager() {
      let shouldDisplay = !!this.$route.query.branding;
      let displaying = localStorage.getItem(
        window.location.origin + "-style-manager"
      );
      if (shouldDisplay) {
        if (!displaying) {
          localStorage.setItem(window.location.origin + "-style-manager", true);
          return;
        }
        return;
      }
      if (displaying) {
        localStorage.removeItem(window.location.origin + "-style-manager");
      }
    },
  },
};
</script>
